import { RemarkRichTextComponents } from "../RichText";
import * as styles from "./styles.module.scss";

export function RichTextBlockquote({
  quote,
  name,
  job,
  author_image,
}: Partial<BlockquoteComponent>) {
  return (
    <blockquote className={styles.customBlockquote}>
      <div className={styles.customBlockquoteContent}>
        {quote?.content && <RemarkRichTextComponents content={quote} />}
      </div>
      <div className={styles.customBlockquoteAuthor}>
        {author_image && author_image?.filename.length > 0 && (
          <img src={author_image.filename} alt={author_image.alt} />
        )}
        <div>
          <p>{name}</p>
          {job && <span>{job}</span>}
        </div>
      </div>
    </blockquote>
  );
}
